import MRM_EXT_1 from "./MRM_EXT_1";
export default {
  MRM_EXT_1,
};
